import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import StackedBarChart from "../../../../components/Charts/StackedBar";
import ViewReportLink from "../ViewReportLink.js";
import LoadingStep from "../../../../components/LoadingStep/index.js";

const widgetName = "MarketingEvents";

const MarketingEvents = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);
	const dispatch = useDispatch();

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div className="widget-container">
			<div className="widget-title">Loading</div>
			<LoadingStep />
		</div>
		)
	}

	const result = {};
	widget.data.data.forEach(m => {
		if(!result[m.Event_Type__c]) {
			result[m.Event_Type__c] = 1;
		}
		else {
			result[m.Event_Type__c]++;
		}
	});

	let datasets = [];
	Object.keys(result).forEach(key => {
		datasets.push({ label: key, values: [result[key]] });
	});

	return (
		<div className="widget-container">
			<div className="widget-title">Marketing Events ({widget.data.data.length})</div>
			<div style={{width: '90%', height: '75%', paddingTop: '50px', paddingRight: '30px', display: 'flex', justifyContent: 'center'}}>
				<StackedBarChart labels={['Marketing Events']} datasets={datasets} />
			</div>
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default MarketingEvents;